module.exports = __webpack_public_path__ + "img/wa.98ce4fd5.png";